import { useEffect, useState } from "react";
import { fetchSharePointSites, type GraphSite } from "../../../email/services/graph";
import { useAuthState } from "../../../../auth/AuthStateProvider";
import { logConnectorFailure, logConnectorSuccess } from "../../../../telemetry";

interface UseSharePointSitesResult {
  sites: GraphSite[];
  loading: boolean;
  error: string | null;
}

export function useSharePointSites(token: string | null): UseSharePointSitesResult {
  const { refreshGraphToken } = useAuthState();
  const [sites, setSites] = useState<GraphSite[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setSites([]);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchSharePointSites(token, refreshGraphToken)
      .then((result) => {
        if (cancelled) return;
        setSites(result);
        logConnectorSuccess("sharepoint", "load-sites");
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setError("Couldn't load SharePoint sites. Try signing in again.");
        logConnectorFailure("sharepoint", e, "load-sites");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [token, refreshGraphToken]);

  return { sites, loading, error };
}
